import mockAxios, { AxiosResponse } from 'axios';

import { ITimeOffServiceMock } from './timeoff.mock.types';

export const mockTimeOffService = (): ITimeOffServiceMock => ({
  fetchTimeOffTypes: jest.fn(),

  fetchAvailableTimeOffTypes: jest.fn(),

  fetchTimeOffTemplates: jest.fn(),
  fetchTimeOffTemplate: jest.fn(),

  downloadTimeOffAttachment: jest.fn(),
  deleteTimeOffAttachment: jest.fn(),

  fetchTimeOffPolicies: jest.fn(),
  createTimeOffPolicy: jest.fn(),
  updateTimeOffPolicy: jest.fn(),
  deleteTimeOffPolicy: jest.fn(),

  rollOverEntitlement: jest.fn(),
  incrementEntitlementYears: jest.fn(),

  exportTimeOffBalances: jest.fn()
});

export const mockTimeOffAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
